export const SITE = {
  name: "PACHAMAMA",
  full: "Pachamama Lombok",
  // TODO: replace with the real WhatsApp number once provided (country code, no "+")
  whatsappNumber: "628000000000",
  whatsappMessage:
    "Hello Pachamama Lombok — I'd like to talk about property in Lombok.",
};

export const waLink = (msg = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
